export enum ESimulationClient {
    PROSPR = 'prospr',
    RIDLEY_CONSULTING = 'ridleyconsulting',
};

export enum ESessionClient {
    MINDSHIELD_TRAINING = 'mindshieldtraining',
    PROSPR = 'prospr',
    RIDLEY_CONSULTING = 'ridleyconsulting',
};

export enum ESimulationKey {
    AUDIT_DEJA_VU = 'audit-deja-vu',
    URGENT_RISK_REQUEST = 'urgent-risk-request',
    SOFT_DOWN_CASE = 'soft-down-case',
    INCOMPLETE_INITIATIVE_SUBMISSION = 'incomplete-initiative-submission',
    TRUSTED_CUSTOMERS = 'trusted-customers',
    EXTRA_DRAWER_KEYS = 'extra-drawer-keys',
    VETERAN_BRANCH_MANAGER = 'veteran-branch-manager',
    THE_SLOGAN_BACKLASH = 'the-slogan-backlash',
    ROCKSTAR_REALITY_CHECK = 'rockstar-reality-check',
};

export enum ESimulationStatus {
    AVAILABLE = 'available',
    COMING_SOON = 'coming-soon',
};

export enum ESimulationStageKey {
    PERSONA_1 = 'persona-1',
    PERSONA_2 = 'persona-2',
    PERSONA_3 = 'persona-3',
};

export enum ESimulationStageStatus {
    NOT_STARTED = 'not-started',
    IN_PROGRESS = 'in-progress',
    COMPLETED = 'completed',
};

export enum ESimulationCompletionStatus {
    NOT_STARTED = 'not-started',
    IN_PROGRESS = 'in-progress',
    COMPLETED = 'completed',
};

export enum EChatSource {
    USER = 'user',
    BOT = 'bot',
};

export enum ESRV1Status {
    AVOIDANT = 'avoidant',
    CONFLICTING = 'conflicting',
    COLLABORATIVE = 'collaborative',
};